<template>
  <div class="modal-body">
    <div class="form-group">
      <label>Masukkan penawaran tertinggi</label>
      <input v-model.lazy="bidAmount" v-money="money" class="form-control" :placeholder="minimumBid" />
      <input type="hidden" name="bid_amount" :value="originalBidAmount">
      <small id="bid-amount-help" class="form-text text-muted">Masukan penawaran dengan kelipatan {{ bidMultiplesAmountInIdr }}</small>
    </div>

    <div class="form-group">
      <input type="submit" name="commit" value="Submit" class="btn btn-primary btn-block" data-confirm="Apakah anda yakin?" data-disable-with="Submitting" :disabled="!validBidAmount" />
      <div class="text-center mt-2">
        Punya pertanyaan? <a href="/">Baca panduan</a>
      </div>
    </div>
  </div>
</template>

<script>
import { VMoney, Money } from 'v-money'

export default {
  components: {
    Money,
  },
  directives: { money: VMoney },
  props: {
    minimumBid: {
      type: Number
    },
    bidMultiplesAmountInIdr: {
      type: String
    },
    openBid: {
      type: Number,
    },
    bidMultiplesAmount: {
      type: Number
    }
  },
  data() {
    return {
      bidAmount: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'Rp ',
        suffix: '',
        precision: 0,
        masked: true,
      }
    }
  },
  computed: {
    originalBidAmount(){
      if (typeof this.bidAmount != 'string'){
        return this.bidAmount
      }
      let unmasked = this.bidAmount.replace('Rp ', '')
      unmasked = unmasked.replace(/\,/g, '')
      unmasked = unmasked.replace(/\./g, '')
      return parseInt(unmasked.trim())
    },
    validBidAmount(){
      if(this.originalBidAmount < this.minimumBid) {
        return false
      }

      if(((this.originalBidAmount - this.openBid) % this.bidMultiplesAmount) != 0) {
        return false
      }

      return true
    }
  },
  mounted(){
    this.bidAmount = this.minimumBid;
  }
}
</script>